import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

const headCells = [
  {
    id: 'MAC', numeric: false, label: 'Seriennummer',
  },
  {
    id: 'Bezeichnung', numeric: false, label: 'Bezeichnung',
  },
];

interface ViewUserDetailsTableHeadProps {
  order: SortingOrder
  orderBy: string
  onRequestSort: Function
}

export default function ViewUserDetailsTableHead({
  order, orderBy, onRequestSort,
} : ViewUserDetailsTableHeadProps) {
  const createSortHandler = (property: string) => (event: any) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={order}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
